import { Card } from '../card/card'
import { QuickView } from '../../../sections/product/quick-view'
import { $el } from 'src/scripts/utils/utils'
import { isEnterKey } from 'src/scripts/utils/key'

const QUICK_VIEW_BUTTON_SELECTOR = '[data-product-card-quick-view-button]'
const QUICK_VIEW_SELECTOR = '#Quick-view'

export class VerticalProductCard extends Card {
  mountComponent(): void {
    const quickViewBtn = $el(QUICK_VIEW_BUTTON_SELECTOR, this)
    this.addListener(quickViewBtn, 'click', this.handleQuickViewBtnClick)
    this.addListener(quickViewBtn, 'keydown', this.handleQuickViewBtnKeyDown)
    this.addListener(this, 'mouseenter', this.handleProductCardEnter)
  }

  handleQuickViewBtnKeyDown = async (event: KeyboardEvent): Promise<void> => {
    if (isEnterKey(event)) {
      event.preventDefault()
      this.callQuickView(true)
    }
  }

  handleQuickViewBtnClick = async (): Promise<void> => {
    this.callQuickView(true)
  }

  handleProductCardEnter = () => {
    this.callQuickView(false)
  }

  async callQuickView(withOpen: boolean) {
    const quickView: QuickView = $el(QUICK_VIEW_SELECTOR)
    const url = this.dataset.url
    const id = this.dataset.id

    if (!quickView || !url || !id) {
      return
    }

    await quickView.requestProductFromUrl(url, id)
    if (withOpen) {
      this.setQuickViewLoading(true)
      await quickView.openAndRenderProductByUrl(url)
      this.setQuickViewLoading(false)
    }
  }

  setQuickViewLoading(isLoading: boolean) {
    const quickViewBtn = $el(QUICK_VIEW_BUTTON_SELECTOR, this)
    if (quickViewBtn) {
      quickViewBtn.classList.toggle('loading', isLoading)
      quickViewBtn.toggleAttribute('disabled', isLoading)
    }
  }
}
